import { render, staticRenderFns } from "./AdminInformation.vue?vue&type=template&id=4de2de74&"
import script from "./AdminInformation.vue?vue&type=script&lang=js&"
export * from "./AdminInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports